import ResourceManager from "../../components/ResourceManager/ResourceManager"
import { StringMap } from "../../types/common"
import { useI18n } from "../../hooks"
import { useOptions } from "../../options/hooks/use-options"
import { useTodoMutations } from "../hooks/use-todo-mutations"
import { TodoViewModel } from "../api/todo"
import { uniq } from "lodash"

const TodoResponsibleWidget = ({ todo, boardId, columnPosition }: TodoResponsibleWidgetProps) => {
  const translations = useTranslations()
  const { membershipOptions } = useOptions(todo.organisation?.id)
  const { updateResponsible } = useTodoMutations()

  const onAddResponsible = (ids: string[]) => {
    const responsible = uniq([...todo.responsible.map((r) => r.id), ...ids]).map((id) => {
      const member = membershipOptions.find((m) => m.id === id)
      return member ? { id: member.id, name: member.name } : { id, name: "" }
    })
    updateResponsible(todo.id, { responsible, boardId, columnPosition })
  }

  const onRemoveResponsible = (id: string) => {
    const responsible = todo.responsible.filter((r) => r.id !== id)
    updateResponsible(todo.id, { responsible, boardId, columnPosition })
  }

  const sortedMembershipOptions = membershipOptions
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

  const sortedResponsible = todo.responsible
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={sortedMembershipOptions}
      resources={sortedResponsible}
      onAddResources={onAddResponsible}
      onRemoveResource={onRemoveResponsible}
      canAddResource={todo.canUpdate}
      canRemoveResource={todo.canUpdate}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection
    />
  )
}
const useTranslations = (defaults = defaultTranslations): Translations => {
  const { translations: t } = useI18n("todo")
  const translations = (t?.responsibleWidget || {}) as StringMap
  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Responsible",
  emptyOptionsMessage: "No members in this organisation",
  emptyResourcesMessage: "This todo does not have responsible",
  updateErrorMessage: "Failed to update responsible",
}

type Translations = typeof defaultTranslations

type TodoResponsibleWidgetProps = {
  todo: TodoViewModel
  boardId?: string
  columnPosition?: number
}

export default TodoResponsibleWidget
